import { Middleware } from '@reduxjs/toolkit';

import { dashboardApi } from '../services/dashboard-api';
import { setIsSidebarExpanded } from '../slices/ui/uiSlice';
import type { RootState } from './rootReducer';

const persistMiddleware: Middleware<void, RootState> = () => next => action => {
  const result = next(action);
  if (setIsSidebarExpanded.match(action)) {
    localStorage.setItem('sidebarToggle', JSON.stringify(action.payload));
  }
  return result;
};

export const middleware = [persistMiddleware, dashboardApi.middleware];
